import { render } from "./move-enrolments-to-history.vue?vue&type=template&id=50f76d1a&ts=true"
import script from "./move-enrolments-to-history.ts?vue&type=script&lang=ts&external"
export * from "./move-enrolments-to-history.ts?vue&type=script&lang=ts&external"

import "./move-enrolments-to-history.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__